// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vNLZS{background:#fff;height:100%;font-family:"Inter",sans-serif}
@media(max-width: 768px){.vNLZS{padding:20px;overflow-y:auto}}
.HlkYE{font-weight:700;color:#0f172a;letter-spacing:-0.2px;line-height:125%;font-size:42px}
@media(max-width: 768px){.HlkYE{font-size:32px}}
.ESkep{font-weight:400;font-size:18px;color:hsl(215,20.2247191011%,60.0980392157%);line-height:1.5;margin-bottom:0}
.neaJ2{color:#0078d4;text-decoration:none;font-size:16px;font-weight:500}
.neaJ2:hover{text-decoration:underline;color:rgb(0,91.1320754717,161)}
.fO4BC{color:#ed4f9d;font-size:16px;font-weight:500;margin-top:10px;padding:12px;background-color:#fef2f2;border:1px solid #fecaca;border-radius:8px;font-family:"Inter",sans-serif}
.bj28J{font-size:64px;color:#16a34a;margin-bottom:24px}
.Z2pHS{font-weight:700;font-size:36px;color:#0f172a;letter-spacing:-0.2px;line-height:125%;margin-bottom:16px}
@media(max-width: 768px){.Z2pHS{font-size:28px}}
.NREwU{font-weight:400;font-size:18px;color:#334155;line-height:1.5;margin-bottom:12px}
.HQ_xF{font-weight:400;font-size:16px;color:hsl(215,20.2247191011%,60.0980392157%);line-height:1.5;margin-bottom:32px}
.Qmy6G{font-weight:400;font-size:16px;color:hsl(215,20.2247191011%,60.0980392157%);margin-bottom:0}
.sBvii{background:none;border:none;color:#0078d4;text-decoration:none;font-weight:500;padding:0;cursor:pointer}
.sBvii:hover{text-decoration:underline;color:rgb(0,91.1320754717,161)}
.sBvii:disabled{opacity:.6;cursor:not-allowed}
.A1jtn{font-size:64px;color:#ed4f9d;margin-bottom:24px}
.lUtZj{font-weight:700;font-size:36px;color:#0f172a;letter-spacing:-0.2px;line-height:125%;margin-bottom:16px}
@media(max-width: 768px){.lUtZj{font-size:28px}}
.mfbEZ{font-weight:400;font-size:18px;color:#334155;line-height:1.5;margin-bottom:32px}
.k1AjY{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;min-height:55vh;padding:32px 16px 16px;padding:2rem 1rem 1rem}
.BwEKv{color:#0078d4 !important;margin-bottom:20px;margin-bottom:1.25rem}
.bPZ1X{font-size:18px;font-size:1.125rem;font-weight:600;color:#0f172a;margin-bottom:8px;margin-bottom:.5rem}
.nX1V7{font-size:15.2px;font-size:.95rem;font-weight:400;color:hsl(215,20.2247191011%,60.0980392157%);line-height:1.5;max-width:352px;max-width:22rem;margin:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rightPanel": `vNLZS`,
	"title": `HlkYE`,
	"subtitle": `ESkep`,
	"backToLoginLink": `neaJ2`,
	"errorMessage": `fO4BC`,
	"successIcon": `bj28J`,
	"successTitle": `Z2pHS`,
	"successText": `NREwU`,
	"successSubText": `HQ_xF`,
	"helpText": `Qmy6G`,
	"linkButton": `sBvii`,
	"errorIcon": `A1jtn`,
	"errorTitle": `lUtZj`,
	"errorText": `mfbEZ`,
	"verifyTokenPanel": `k1AjY`,
	"verifyTokenSpinner": `BwEKv`,
	"verifyTokenTitle": `bPZ1X`,
	"verifyTokenMessage": `nX1V7`
};
module.exports = ___CSS_LOADER_EXPORT___;
